export const UPDATE_TEXT_INPUT = 'UPDATE_TEXT_INPUT';
export const UPDATE_COLUMN_TEXT_INPUT = 'UPDATE_COLUMN_TEXT_INPUT';
